import React from 'react';
import PropTypes from 'prop-types';
import DefaultSelect from 'components/DefaultSelect';

const TrueFalseSelectV2 = ({ error, label, name, onChange, value, disabled, isRequired, showEmpty }) => (
  <DefaultSelect
    error={error} isRequired={isRequired} label={label} name={name} showEmpty={showEmpty}
    onSelect={onChange}
    options={[
      { id: 'true', descricao: 'Sim' },
      { id: 'false', descricao: 'Não' }
    ]}
    value={value}
    handlerOption={option => option.descricao}
    disabled={disabled}
  />
);

TrueFalseSelectV2.propTypes = {
  error: PropTypes.bool, label: PropTypes.string, name: PropTypes.string,
  onChange: PropTypes.func, value: PropTypes.string, disabled: PropTypes.bool,
  isRequired: PropTypes.any, showEmpty: PropTypes.bool
};
TrueFalseSelectV2.defaultProps = { value: '', onChange: () => {}, showEmpty: false };
export default TrueFalseSelectV2;
